goog.module('yext.spark.admin.rules.init');
goog.module.declareLegacyNamespace();
const Table = goog.require('yext.table.Table');

/**
 * Initialize the View Rules page
 */
const init = function() {
  let table = new Table(
    $('.js-rules-table'),
    $('.js-rules-filter'));
  table.bind('/spark2/rules/search');
};
goog.exportSymbol('yext.spark.admin.rules.init', init);

exports = init;
